export default {
    fund: [{
            "title": "关于基金销售机构，以下表述正确的是（　　）。",
            "question": "A．商业银行可以开展基金直销代办和代销业务\nB．保险公司不能开展基金代销业务\nC．基金公司可以开展基金直销业务\nD．证券交易所可以开展基金代销业务",
            "answer": "C",
            "explain": "我国基金销售市场现有基金公司直销和代销两种主要的销售方式。基金直销是指通过基金公司或基金公司网站进行基金买卖。基金代销是指拥有代销资格的银行或证券公司等金融机构接受基金管理人的委托，通过营业网点柜台、电话、网络等渠道为投资人办理基金份额认购、申购和赎回以及相应资金收付的业务。"
        },
        {
            "title": "基金管理人在收到基金准予注册文件六个月之后才开始募集，原注册的事项未发生实质性变化的，应用国务院证券监督管理机构（　　）。",
            "question": "A．提交延期申请\nB．重新提交注册申请\nC．备案\nD．口头说明",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "根据基金从业人员职业道德规范的要求，以下做法错误的是（　　）。",
            "questions": "I．基金经理甲、乙二人，通过两人管理的产品相互交易增加交易量来提升股价<br>II．基金研究员丙，通过互联网发布关于A、B两公司的不实消息，压低两公司股价<br>III．某基金销售机构的人员，参加某基金管理公司组织的“年终会议”，并接受了“年终纪念”礼物<br>IV．某基金管理公司在产品募集过程中，承诺为前100名投资的客户赠送海南豪华旅行计划",
            "question": "A．I、II、III\nB．I、II\nC．I、III\nD．I、II、III、IV",
            "answer": "D",
            "explain": "操纵市场，是指通过扭曲证券价格形成机制或人为控制交易量等方式而意图误导市场参与者的行为。操纵市场的构成要素有两方面：一是有误导市场参与者的意图；二是实施了歪曲证券价格或者人为控制交易量等不当影响证券价格的行为。基金从业人员不得通过操纵市场牟取不正当利益，不得利用资金优势、持股优势和信息优势，单独或者合谋串通，影响证券交易价格或交易量，误导和干扰市场。"
        },
        {
            "title": "公募基金管理公司督察长的聘任、解聘和考核应由（　　）决定。",
            "question": "A．总经理\nB．监事会\nC．股东会\nD．董事会",
            "answer": "D",
            "explain": "董事会决定督察长的聘任、解聘和考核，决定其薪酬待遇。董事会应当建立和完善督察长考核和薪酬管理制度，应以合规运作为主要标准，促进提高公司合规管理的有效性。公司应保证督察长工作的独立性，不得安排或者要求督察长从事基金销售、投资等与其履行职责相冲突的职务和工作。同时公司应该为合规管理提供保障，包括为合规部门配备足够的、具备履职能力的专业人员，建立合规独立性的考核方式和相应的薪酬管理制度。"
        },
        {
            "title": "关于客户至上的基本要求，以下描述错误的是（　　）。",
            "question": "A．客户至上要求基金从业人员应做到客户利益优先\nB．公司应做到客户利益、股东利益、员工利益并重\nC．客户至上要求基金从业人员应做到公平对待客户\nD．客户至上要求基金从业人员的执业活动应一切从客户的根本利益出发",
            "answer": "B",
            "explain": "本题考查客户至上的内容。客户至上，是指基金从业人员的执业活动应一切从投资人的根本利益出发。其基本含义有两点：一是客户利益优先，二是公平对待客户。客户利益优先是指当客户的利益与机构的利益、从业人员个人的利益相冲突时，要优先满足客户的利益；公平对待客户是指当不同客户之间的利益发生冲突时，要公平对待所有客户的利益。"
        },
        {
            "title": "关于合规审核，以下表述错误的是（　　）。",
            "question": "A．合规审核的目标是把外部监督可能发现的问题及时在内部发现并进行有效的处理\nB．对于合规审核的效果评价可以请第三方评估机构实施\nC．合规部门人员可采用任何调查手段开展合规审核调查\nD．合规审核能够有效降低基金管理人受到处罚的可能性",
            "answer": "C",
            "explain": "基金管理人在公司内部开展合规审核时，可能出现内部人员不配合，刻意隐瞒实情，需要合规部门人员进行审核调查。合规审核调查需要利用先进的技术包括数据分析技术，但审核调查手段不能干扰公司日常的业务运作。"
        }, {
            "title": "投资者教育是一项重要工作，也是一项长期的、基础性的常规性的工作，原因在于（　　）。",
            "questions": "I．法律法规在不断建立和健全<br>II．金融产品和金融工具不断创新<br>III．大量银行储户分流到证券市场<br>IV．投资者存在非理性心理偏差",
            "question": "A．I．II．III．IV\nB．II．III．IV\nC．I．II．IV\nD．I．II．III",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "道德是一种行为规范，它调整的关系是（　　）。",
            "question": "A．人与人的关系、人与社会的关系\nB．人与自然的关系、人与人的关系\nC．人与自然的关系、人与人的关系以及人与社会的关系\nD．人与职业的关系、人与人的关系以及人与自然的关系",
            "answer": "A",
            "explain": "道德，是一种社会意识形态，是由一定的社会经济基础决定并形成的，以是与非、善与恶、美与丑、正义与邪恶、公正与偏私、诚实与虚伪等范畴为评价标准，依靠社会舆论、传统习俗和内心信念等约束力量，实现调整人与人之间、人与社会之间关系的行为规范的总和。"
        },
        {
            "title": "基金从业人员的以下行为中，不符合专业审慎职业道德规范要求的包括（　　）。",
            "questions": "I．王某发现同事购买股票但未按公司规定进行事前申报，王某向公司报告<br>II．张某向风险承受能力低的客户主动推荐超越其风险承受能力的高风险基金<br>III．刘某将其他公司的研究报告直接作为自己的研究报告提交给公司<br>IV．李某利用职务便利为自己牟取非法利益",
            "question": "A．I．II\nB．I．II．III．IV\nC．II．III．IV\nD．II．III",
            "answer": "D",
            "explain": "报告他人有利益冲突的行为属于守法合规的规范要求，为自己牟取私利的行为违反了客户至上的职业道德规范。"
        },
        {
            "title": "基金管理人所有员工在从事业务时必须做到（　　），并以最高水准要求自己。",
            "questions": "I．忠诚<br>II．诚实<br>III．公平交易<br>IV．自觉自愿",
            "question": "A．II、III、IV\nB．I、II、III\nC．I、II、III、IV\nD．I、II、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "基金销售机构应根据规定，监测客户现金收支或款项划转情况，及时向中国反洗钱监测分析中心报告，中国反洗钱监测分析中心是为（　　）履行组织协调国家反洗钱工作职责而设立的收集、分析、监测和提供反洗钱的专门机构。",
            "question": "A．中国证券投资基金业协会\nB．中国银行保险监督管理委员会\nC．中国证券监督管理委员会\nD．中国人民银行",
            "answer": "D",
            "explain": "基金销售机构应根据中国人民银行《金融机构大额交易和可疑交易报告管理办法》第9条和第10条规定，监测客户现金收支或款项划转情况，对符合大额交易标准的，在该大额交易发生后5个工作日内，向中国反洗钱监测分析中心报告。"
        },
        {
            "title": "关于基金从业人员离职时应当履行的相应义务，以下表述正确的是（　　）。",
            "questions": "I．按照聘用合同约定的期限提前向公司提出申请<br>II．已提出辞职但尚未完成工作移交的，从业人员应认真履行各项义务，不得擅自离岗<br>III．认真履行保密、竞业禁止等义务<br>IV．整理工作中积累的客户联系信息便于自己以后工作联系",
            "question": "A．I．II．III\nB．I．II．III．IV\nC．II．III．IV\nD．I．III．IV",
            "answer": "A",
            "explain": ""
        }, {
            "title": "关于投资基金的类别，以下表述正确的包括（　　）。",
            "questions": "I．按照运作方式，投资基金分为一对一型和一对多型<br>II．按照法律形式，投资基金分为合伙型和公司型<br>III．按照资金募集方式，投资基金分为公募型和私募型<br>IV．按照投资对象，投资基金分为传统型和另类型",
            "question": "A．I．II\nB．III．IV\nC．I．IV\nD．II．III",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "以下可体现基金公司督察长工作独立性的是（　　）。",
            "question": "A．督察长有权参加或者列席公司经营决策会议\nB．督察长不得从事基金销售相关的工作\nC．督察长可以以公司的名义直接聘请外部专业机构协助工作，费用由公司承担\nD．督察长应对公司的新产品出具合规意见",
            "answer": "B",
            "explain": "公司应保证督察长工作的独立性，不得安排或者要求督察长从事基金销售、投资等与其履行职责相冲突的职务和工作。同时公司应该为合规管理提供保障，包括为合规部门配备足够的、具备履职能力的专业人员，建立合规独立性的考核方式和相应的薪酬管理制度。"
        },
        {
            "title": "通常在开放式基金申购赎回中，可以不采用未知价交易原则的基金品种为（　　）。",
            "question": "A．混合型基金\nB．股票型基金\nC．债券型基金\nD．货币市场基金",
            "answer": "D",
            "explain": "货币市场基金按照确定价原则进行交易，基金申购、赎回基金份额价格以1元人民币为基准进行计算。其他选项均采用未知价交易原则。"
        },
        {
            "title": "基金销售人员陈述所推介基金的业绩时，以下行为不合格的是（　　）。",
            "question": "A．用所推介基金的过往业绩适当测算其未来表现\nB．未对所推介基金的未来业绩作出预测\nC．陈述推介基金的历史业绩，并提供业绩信息的原始出处\nD．引用第三方基金评价机构的评价结果推介基金",
            "answer": "A",
            "explain": "过往业绩不能代表未来表现。基金宣传推介材料登载该基金、基金管理人管理的其他基金的过往业绩，应当遵守下列规定：(1)按照有关法律法规的规定或者行业公认的准则计算基金的业绩表现数据。"
        },
        {
            "title": "公募基金管理人申请募集基金时，应向中国证监会提交的募集申请文件包括（　　）。",
            "questions": "I．律师事务所出具的法律意见书<br>II．基金合同草案、基金托管协议草案和招募说明书草案<br>III．会计师事务所出具的审计报告<br>IV．基金募集申请报告",
            "question": "A．II、III、IV\nB．I、II、IV\nC．II、IV\nD．I、II、III、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "针对ETF特有的证券申购、赎回机制，以及一二级市场并存的交易制度安排，交易所的业务规则规定了ETF特殊的信息披露事项，以下表述错误的是（　　）。",
            "question": "A．对于当日发布的申购、赎回清单，当日不得修改\nB．在每日收市后披露当日的申购、赎回清单\nC．在交易时间内即时揭示基金份额参考净值(IOPV)\nD．申购、赎回清单通过基金公司官方网站及证券交易所指定渠道予以公告",
            "answer": "B",
            "explain": "在每日开市前（而不是收市后），基金管理人需要向证券交易所、证券登记结算机构提供ETF的申购、赎回清单，并通过基金公司官方网站和证券交易所指定的信息发布渠道予以公告。其他选项均为披露要求。"
        }, {
            "title": "某投资者赎回开放式基金2万份，持有时间为1年，对应的赎回费率为0.5%，赎回费用的25%归入基金资产，赎回当日基金单位净值为1.0元，以下正确的是（　　）。",
            "question": "A．投资者可得到的净赎回金额为19959.7元\nB．赎回总金额为20035元\nC．归入基金资产的赎回费为25元\nD．赎回费用为100元",
            "answer": "A",
            "explain": "赎回总金额=20000*1.003=20060（元），赎回费用=20060*0.5%=100.3（元），归入基金资产的赎回费收入=100.3*25%=25.075（元），投资者可得到的净赎回金额=20060-100.3=19959.7（元）。"
        },
        {
            "title": "投资者于交易日申购某开放式基金，申购金额5万元，申购手续费500元。申购当日基金份额净值为1.012元，份额确认日基金份额净值为1.00元，投资者当日的有效申购份额为（　　）份。",
            "question": "A．48907.11\nB．49058.47\nC．48913.04\nD．49500",
            "answer": "C",
            "explain": "当申购费用为固定金额时，申购份额的计算方法如下：净申购金额=申购金额-申购费用=50000-500=49500元；申购份额=净申购金额/申购当日基金份额净值=49500/1.012=48913.04份。"
        },
        {
            "title": "关于公募基金年度报告中投资组合部分应披露的信息，下列表述错误的是（　　）。",
            "question": "A．应披露期末按市值占比排序的所有股票明细\nB．应披露期末按市值占比排序的所有债券明细\nC．应披露投资贵金属、股指期货、国债期货等情况\nD．应披露期末基金资产组合",
            "answer": "B",
            "explain": "基金投资组合报告的披露内容包括：(1)期末基金资产组合；(2)期末按行业分类的股票投资组合；(3)期末按市值占基金资产净值比例大小排序的所有股票明细；(4)报告期内股票投资组合的重大变动。"
        },
        {
            "title": "关于基金信息披露的作用，以下表述错误的是（　　）。",
            "question": "A．有利于基金份额持有人判断是否值得继续持有\nB．有利于投资者判断是否适合投资\nC．有利于基金份额持有人评价其所持有基金的基金经理的管理水平\nD．有利于基金份额持有人对基金投资运作及时提出建议",
            "answer": "D",
            "explain": "在基金运作过程中，通过充分披露基金投资组合、历史业绩和风险状况等信息，现有持有人可以评价基金经理的管理水平，了解基金投资是否符合基金合同的承诺，从而判定该基金产品是否值得继续持有。"
        },
        {
            "title": "基金管理人内部控制的总体目标包括（　　）。",
            "questions": "I．保证公司经营运作严格遵守国家有关法律法规和行业监管规则<br>II．防范和化解经营风险，提高经营管理效益，实现公司的持续、稳定、健康发展<br>III．确保基金和基金管理人的财务和其他信息真实、准确、完整<br>IV．保障基金从业人员的利益",
            "question": "A．I、II\nB．I、II、III、IV\nC．I、IV\nD．I、II、III",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于封闭式基金的交易报价，下列说法正确的是（　　）。",
            "questions": "I．基金的申报价格最小变动单位为0.01元人民币<br>II．基金报价单位为每10份基金价格<br>III．基金买卖申报数量应当为100份或其整数倍<br>IV．基金单笔最大数量应当低于100万份",
            "question": "A．I、II、IV\nB．III、IV\nC．II、IV\nD．I、II",
            "answer": "B",
            "explain": "封闭式基金的报价单位为每份基金价格。基金的申报价格最小变动单位为0.001元人民币。买入与卖出封闭式基金份额，申报数量应当为100份或其整数倍。基金单笔最大数量应当低于100万份。"
        }, {
            "title": "关于基金从业人员守法合规的要求，以下表述错误的是（　　）。",
            "question": "A．基金管理机构应为从业人员熟悉法律法规等创造条件\nB．当不同效力级别的规范对同一行为有不同规定时，应选择遵守更高效力的规范\nC．基金从业人员应当监督他人行为是否符合法律法规的要求\nD．基金从业人员应熟悉并自觉遵守法律法规",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于金融与居民理财，下列说法错误的是（　　）。",
            "question": "A．居民理财的主要方式是货币储蓄和投资两类\nB．居民的消费、储蓄与投资意愿跟金融市场的表现关联度较低\nC．在生产经营活动中，收入产生盈余的居民希望将他们的货币盈余使用出去，因此产生理财的需求\nD．所谓金融，简单来讲即货币资金的融通，而货币资金的来源为居民（包括个人和企业）从事的生产活动",
            "answer": "B",
            "explain": "所谓金融，简单来讲即货币资金的融通。货币资金来源于居民（包括个人和企业）从事的生产活动，“来源为居民（包括个人和企业）从事的生产活动”说法正确。"
        },
        {
            "title": "下列关于股票基金的表述，不正确的是（　　）。",
            "question": "A．股票基金以追求长期的资本增值为目标\nB．与其他类型的基金相比，股票基金的风险较高，预期收益也较高\nC．长期来看，股票基金提供了应对通货膨胀的有效手段\nD．股票基金能给投资者带来确定收入",
            "answer": "D",
            "explain": "股票基金以追求长期的资本增值为目标，比较适合长期投资。与其他类型的基金相比，股票基金的风险较高，但预期收益也较高。股票基金提供了一种长期的投资增值性，可供投资者用来满足教育支出、退休支出等远期支出的需要。与房地产一样，股票基金是应对通货膨胀最有效的手段。债券基金主要以债券为投资对象，因此对追求稳定收入的投资者具有较强的吸引力。"
        },
        {
            "title": "关于基金市场服务机构，以下说法错误的是（　　）。",
            "question": "A．基金管理人不可以委托其他机构代为办理基金估值核算业务\nB．基金管理人可以委托其他机构代为办理基金份额登记业务\nC．从事公开募集基金投资顾问业务的机构，应当向中国证监会派出机构申请注册\nD．基金管理人、基金托管人既是基金的当事人，又是基金的主要服务机构",
            "answer": "A",
            "explain": "基金管理人可以自行办理基金估值核算业务，也可以委托基金估值核算机构代为办理基金估值核算业务。"
        },
        {
            "title": "某货币市场基金T日规模20亿元，下列情形中，T+1日触发巨额赎回的是（　　）。",
            "question": "A．T+1日接受申购1亿元，赎回3亿元，基金转换转出0.5亿元，转入0.6亿元\nB．T+1日接受申购0.3亿元，赎回1.3亿元，基金转换转出1亿元，转入0.3亿元\nC．T+1日接受申购0.1亿元，赎回1.2亿元，基金转换转出0.5亿元，转入0.3亿元\nD．T+1日接受申购0.5亿元，赎回1.5亿元，基金转换转出1.5亿元，转入0.2亿元",
            "answer": "D",
            "explain": "本题考查开放式基金巨额赎回的认定及处理。单个开放日基金净赎回申请超过基金总份额10%时，为巨额赎回。单个开放日的净赎回申请，是指该基金的赎回申请加上基金转换中该基金的转出申请之和，扣除当日发生的该基金申购申请及基金转换中该基金的转入申请之和后得到。"
        },
        {
            "title": "某券商为已取得基金托管资格的基金托管人。当发生下列（　　）事项时，该券商应在事件发生之日起2日内编制并披露临时公告书。",
            "questions": "I．该券商基金托管部负责人变动<br>II．该券商基金托管部主要业务人员1年内离职率约为10%<br>III．托管人的法定名称或住所发生变更<br>IV．该券商因托管业务发生违约被提起诉讼",
            "question": "A．I、II、IV\nB．II、III\nC．I、IV\nD．I、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "根据《证券投资基金法》，关于基金份额持有人大会日常机构的规定，以下表述错误的是（　　）。",
            "question": "A．公募证券投资基金份额持有人大会应当设有日常机构\nB．日常机构不得直接参与或者干涉基金的投资管理活动\nC．日常机构有权召集基金份额持有人大会\nD．日常机构由基金份额持有人大会选举产生的人员组成",
            "answer": "A",
            "explain": "基金份额持有人大会的日常机构，由基金份额持有人大会选举产生的人员组成；其议事规则，由基金合同约定。基金份额持有人大会及其日常机构不得直接参与或者干涉基金的投资管理活动。"
        }, {
            "title": "某基金公司对所管理的基金进行持续营销，在其微信公众号发布了题为“今年以来收益率超20%”的营销文案且未载明历史业绩。（　　）",
            "question": "A．销售合规性风险\nB．投资合规性风险\nC．信息披露合规性风险\nD．反洗钱合规性风险",
            "answer": "C",
            "explain": "基金管理人信息披露合规性风险是指基金管理人在信息披露过程中，违反相关法律法规和公司规章，对基金投资者形成了误导或对造成了不良声誉，受到处罚和声誉损失的风险。"
        },
        {
            "title": "基金托管人连续（　　）年未开展基金托管业务的，监管机构可取消其基金托管资格。",
            "question": "A．5\nB．10\nC．7\nD．3",
            "answer": "D",
            "explain": "中国证监会、国务院银行业监督管理机构对有下列情形之一的基金托管人，可以取消其基金托管资格：①连续3年没有开展基金托管业务的；②违反《证券投资基金法》规定，情节严重的；③法律、行政法规规定的其他情形。"
        },
        {
            "title": "关于基金销售机构与投资者的互动交流，以下错误的是（　　）。",
            "question": "A．做好客户服务日志及客户资料的更新、完善\nB．及时同客户传递重要市场资讯，建议申购、赎回基金的时点\nC．进行电话回访，改善客户体验\nD．深入了解客户需求，确定和记录客户服务标准",
            "answer": "B",
            "explain": "互动交流是基金销售机构与投资者深入探讨的重要方式，其交流内容包括：做好客户服务日志及客户资料的更新、完善；进行电话回访，改善客户体验；深入了解客户需求，确定和记录客户服务标准。"
        },
        {
            "title": "关于基金销售机构的准入条件，以下表述正确的是（　　）。",
            "question": "A．保险机构应向国家金融监督管理总局进行注册并取得相应资格\nB．证券公司应向中国证券业协会进行注册并取得相应资格\nC．基金管理公司应向工商注册登记所在地的中国证监会派出机构进行注册并取得相应资格\nD．独立基金销售机构应向工商注册登记所在地的中国证监会派出机构进行注册并取得相应资格",
            "answer": "D",
            "explain": "基金管理人可以办理其募集的基金产品的销售业务。商业银行、证券公司、期货公司、保险机构、证券投资咨询机构、独立基金销售机构以及中国证监会认定的其他机构从事基金销售业务的，应向工商注册登记所在地的中国证监会派出机构进行注册并取得相应资格。"
        },
        {
            "title": "关于基金管理合规管理的定义，以下表述错误的是（　　）。",
            "question": "A．对基金管理人开展的相关业务是否存在与现行法律法规、相关行业准则有悖的行为进行风险识别、检查、通报、评估、处置等的活动\nB．基金管理人的一种风险管理活动\nC．对基金管理人是否合法合规经营的一系列鉴证行为\nD．管理、操纵和监督基金管理人相关业务",
            "answer": "D",
            "explain": "所谓“合规”，与“违规”相对应，是指基金管理人的经营管理活动与法律、规则和准则一致。因此，合规管理是一种风险管理活动，是对业务活动是否遵守法律、监管规定、规则、行业自律准则等一种鉴证行为。"
        },
        {
            "title": "机构开展基金销售业务，应具备的条件不包括（　　）。",
            "question": "A．委托商业银行开展反洗钱工作\nB．基金销售业务技术系统通过相应技术系统联网测试，测试结果符合国家规定标准\nC．有与基金销售业务相适应的营业场所、安全防范设施\nD．具有健全的治理结构",
            "answer": "A",
            "explain": "申请注册基金销售业务资格，应当具备下列条件：具有健全的治理结构、完善的内部控制和风险管理制度，并得到有效执行。"
        }, {
            "title": "基金管理人应当在（　　）中载明以下有关基金销售费用的信息：一、基金销售费用收取的条件、方式、用途和费用标准；二、采用示例方式向投资人说明基金费用水平；三、中国证监会规定的其他有关基金销售费用的信息事项。",
            "questions": "I．招募说明书<br>II．基金份额发售公告<br>III．基金合同<br>IV．托管协议",
            "question": "A．II、III\nB．I、IV\nC．I、III\nD．I、II",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于专业投资者和普通投资者，以下描述正确的是（　　）。",
            "question": "A．相对于普通投资者，专业投资者的风险识别和承受能力更弱\nB．专业投资者是大的机构，在基金经营机构享有不同于普通投资者的优先服务\nC．专业投资者与基金经营机构发生纠纷，适用准主张谁举证原则，普通投资者与基金经营机构发生纠纷，适用举证责任倒置原则\nD．专业投资者是在单个行业具有较强投资能力的投资者，普通投资者在多个行业都有较强投资能力的投资者",
            "answer": "C",
            "explain": "专业投资者在多个行业都有较强投资能力的投资者；专业投资者并不全是大的机构，也有自然人；相对于普通投资者，专业投资者的风险识别和承受能力更强。"
        },
        {
            "title": "关于QDII基金的信息披露，以下表述错误的是（　　）。",
            "question": "A．可以同时采用中文和英文，但需要明确告知投资者以哪种文字为准\nB．当投资顾问主要负责人变动时，需要发布临时公告\nC．投资境外基金的，应当披露QDII基金和境外基金之间的费率安排\nD．定期报告中披露计入当期损益的汇兑损益",
            "answer": "A",
            "explain": "QDII基金在披露相关信息时，可同时采用中文和英文，并以中文为准，可单独或同时以人民币、美元等主要外汇币种计算并披露净值信息。"
        },
        {
            "title": "以下不属于基金管理公司管理层下设的风险管理委员会职责是（　　）。",
            "question": "A．每日监控风险敞口，对风险管理决策和风险管理制度执行情况进行日常检查、评估和报告\nB．重点关注内控机制薄弱环节和可能给公司带来重大损失的事件，提出控制措施和解决方案\nC．制定相关风险控制政策，审批风险管理重要流程和风险敞口管理体系\nD．指导、协调和监督各职能部门和各业务单元开展风险管理工作",
            "answer": "A",
            "explain": "公司管理层下可以设立履行风险管理职能的委员会，专业风险管理委员会对管理层负责，协助管理层履行以下职责：1.指导、协调和监督各职能部门和各业务单元开展风险管理工作；2.制订相关风险控制政策，审批风险管理重要流程和风险敞口管理体系，并与公司整体业务发展战略和风险承受能力相一致；3.识别公司各项业务所涉及的各类重大风险，对重大事件、重大决策和重要业务流程的风险进行评估，制定重大风险的应对措施。"
        },
        {
            "title": "不需要在基金合同、招募说明书中约定赎回费的收取标准和计入基金财产的比例的基金是（　　）。",
            "question": "A．LOF\nB．社保基金\nC．分级基金\nD．ETF",
            "answer": "B",
            "explain": "本题考查开放式基金的赎回。各项社会保险基金按照社会保险险种分别建账，分账核算，然后执行国家统一的会计制度。无需在基金合同、招募说明书中约定赎回费的收取标准和计入基金财产的比例。"
        },
        {
            "title": "关于私募投资基金监督管理，以下说法正确的是（　　）。",
            "question": "A．建立健全私募基金发行监管制度，注意事前监管\nB．允许各类发行主体在依法合规的基础上，向累计不超过法律规定数量的投资者发行私募基金\nC．设立私募基金管理机构须经监管机构行政审批\nD．发行私募基金须经监管机构行政审批",
            "answer": "B",
            "explain": "《私募投资基金监督管理暂行办法》规定，设立私募基金管理机构和发行私募基金不设行政审批，允许各类发行主体在依法合规的基础上，向累计不超过法律规定数量的投资者发行私募基金。"
        }, {
            "title": "下列不属于证券交易所职能的是（　　）。",
            "question": "A．负责交易所上市基金的信息披露监管工作\nB．负责对基金在交易所内的投资交易活动进行监管\nC．对违法违规行为采取行政处罚措施\nD．依法制定上市规则、交易规则、会员管理规则等",
            "answer": "C",
            "explain": "中国证监会对基金市场的监管措施：检查、调查取证、限制交易和行政处罚，故“对违法违规行为采取行政处罚措施”项错误，属于证监会职能而不是证券交易所职能。"
        },
        {
            "title": "募集机构应在风险揭示书中明示的私募基金的一般风险包括（　　）。",
            "questions": "I．资金损失风险<br>II．流动性风险<br>III．投资标的风险<br>IV．税收风险",
            "question": "A．I、II、IV\nB．I、II、III、IV\nC．I、II、III\nD．II、III、IV",
            "answer": "B",
            "explain": "私募基金的一般风险，包括资金损失风险、基金运营风险、流动性风险、募集失败风险、投资标的的风险、税收风险等。故全选。"
        },
        {
            "title": "关于基金销售机构人员的管理和培训，以下表述错误的是（　　）。",
            "question": "A．基金销售机构应完善销售人员的招聘程序等\nB．为保护隐私，基金销售机构可以不用对外公示本机构销售人员的相关信息\nC．对通过基金销售资格考试的基金销售人员，基金销售机构需统一办理执业注册，后续培训等\nD．基金销售机构应建立科学合理的销售绩效评价体系",
            "answer": "B",
            "explain": "基金销售机构应通过网络或其他方式向社会公示本机构所属的取得基金销售从业资质的人员信息，公示的内容包括但不限于姓名、从业资质证明及编号，所在营业网点等信息。"
        },
        {
            "title": "私募基金管理人应当建立完善的财产分离制度，包括（　　）要实行独立运作，分别核算。",
            "questions": "I．不同基金财产之间<br>II．基金管理人财产和托管人财产之间<br>III．基金财产和其他财产<br>IV．基金财产与基金管理人固有财产之间",
            "question": "A．I、III、IV\nB．I、II、III\nC．I、II、III、IV\nD．I、II、IV",
            "answer": "A",
            "explain": "私募基金管理人应当建立完善的财产分离制度，私募基金财产与私募基金管理人固有财产之间，不同私募基金财产之间，私募基金财产和其他财产之间要实行独立运作，分别核算。"
        },
        {
            "title": "关于基金风险评估，以下表述正确的是（　　）。",
            "questions": "I．风险评估可采用定性和定量相结合的方法<br>II．风险评估就是识别和分析与现实目标相关的风险，从而为管理风险奠定基础<br>III．风险评估可以准确预测公司所面临的风险",
            "question": "A．I、II、III\nB．I、II\nC．I、III\nD．II、III",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "以下不属于道德的调整手段的是（　　）。",
            "question": "A．内心信念\nB．国家强制力\nC．传统习俗\nD．社会舆论",
            "answer": "B",
            "explain": "法律主要依靠国家强制力保证实施，而道德主要依靠社会舆论、传统习俗和内心信念等力量来实现其约束力。相比法律，道德的调整手段更多，但均不具有强制性。因此，法律的实施主要靠他律，而道德的实施主要依靠自律。"
        }, {
            "title": "以下金融工具中，属于受益凭证的是（　　）。",
            "questions": "I．股票<br>II．基金<br>III．债券<br>IV．银行储蓄存款",
            "question": "A．II、III、IV\nB．I、II、III、IV\nC．I\nD．II",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "中国证监会有权对基金市场采取下列哪些监管措施（　　）。",
            "questions": "I．对基金机构现场检查，要求其报送有关业务资料<br>II．进入涉嫌违法行为发生场所调查取证<br>III．对于操纵证券市场的当事人，限制其证券买卖<br>IV．对于涉嫌犯罪的相关机构和人员追究刑事责任",
            "question": "A．II、III、IV\nB．I、III\nC．II、IV\nD．I、II、III",
            "answer": "D",
            "explain": "中国证监会对基金市场的监管措施：对基金机构现场检查，要求其报送有关业务资料；进入涉嫌违法行为发生场所调查取证；对于操纵证券市场的当事人，限制其证券买卖；对于涉嫌犯罪的相关机构和人员追究刑事责任。"
        },
        {
            "title": "甲投资人赎回某开放式混合型基金C类基金份额(收取销售服务费)，持有期为20日，收取的赎回费率为0.5%，赎回费为100元。该赎回费计入基金财产的金额为（　　）。",
            "question": "A．50元\nB．75元\nC．25元\nD．100元",
            "answer": "D",
            "explain": "对于收取销售服务费的(一般为C类份额)一般股票型和混合型基金赎回费归属基金财产比例的规定为：对持续持有期少于7日的投资者收取不低于1.5%的赎回费，对持续持有期少于30日的投资人收取不低于0.5%的赎回费，并将上述赎回费全额计入基金财产。"
        },
        {
            "title": "某基金管理人拟成立有限合伙形式的私募基金投资于未上市公司股权，关于该基金的托管，以下说法正确的是（　　）。",
            "question": "A．基金管理人可以在有限合伙协议中未明确约定该基金是否进行托管时，有权独立决定是否进行托管\nB．由于该基金为有限合伙形式，基金托管人不是有限合伙协议的主体，因此本基金无法由基金托管人托管\nC．无托管时，有限合伙协议中均应当明确保障私募基金财产安全的制度措施和纠纷解决机制\nD．由于该基金投资于未上市股权，风险较大，所以必须进行托管",
            "answer": "C",
            "explain": "《私募投资基金监督管理暂行办法》规定，除基金合同另有约定外，私募基金应当由基金托管人托管。基金合同约定私募基金不进行托管的，应当在基金合同中明确保障私募基金财产安全的制度措施和纠纷解决机制。"
        },
        {
            "title": "《证券投资基金销售管理办法》规定：基金宣传推介材料登载基金业绩的，备案文件应包括（　　）。",
            "question": "A．代销机构出具的基金业绩复核函\nB．基金公司出具的基金业绩复核函\nC．基金托管人出具的基金业绩复核函\nD．属地证监局出具的基金业绩复核函",
            "answer": "C",
            "explain": "报送内容包括基金宣传推介材料的形式和用途说明，基金宣传推介材料，基金管理公司督察长出具的合规意见书，基金托管银行出具的基金业绩复核函或基金定期报告中相关内容的复印件，以及有关获奖证明的复印件。基金业绩表现数据应当经基金托管人复核或者摘取自基金定期报告。"
        },
        {
            "title": "以下属于基金管理人监事会依法行使的职权是（　　）。",
            "question": "A．提议召开董事会会议\nB．检查公司的财务\nC．主持召开临时股东会\nD．罢免对发生重大合规风险负有主要责任的董事",
            "answer": "B",
            "explain": "基金管理人监事会的职权包括：(1)检查公司的财务；(2)对公司董事和高级管理人员履行合规管理职责的情况进行监督；(3)对发生重大合规风险负有主要责任或领导责任的董事和高级管理人员提出罢免的建议；(4)提议召开临时股东会；(5)列席董事会会议；(6)公司章程规定的其他职权。"
        }, {
            "title": "某投资者认购10万元开放式基金，在募集期间产生利息10元，认购费率为1.0%，基金份额按面值1元发售，其净认购金额和认购份额为（　　）。",
            "question": "A．100000元，100010份\nB．100000元，100000份\nC．99009.90元，99019.90份\nD．99009.90元，99009.90份",
            "answer": "C",
            "explain": "根据公式：净认购金额=认购金额/(1+认购费率)；认购份额=(净认购金额+认购利息)/基金份额面值；根据题中可得净认购金额=100000/(1+1%)=99009.9(元)；认购份额=(99009.9+10)/1=99019.90(份)。"
        },
        {
            "title": "按《公开募集证券投资基金信息披露管理办法》规定，基金管理人应及时予以临时披露的信息包括（　　）。",
            "questions": "I．基金份额持有人大会的召开<br>II．基金经理和基金托管人的基金托管部门负责人变更<br>III．基金份额净值计价错误金额达基金份额净值的0.5%<br>IV．开放式基金发生巨额赎回但正常办理赎回业务",
            "question": "A．I、II、III\nB．I、III、IV\nC．I、II、III、IV\nD．II、III、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "开展审慎调查应当优先根据被调查方公开披露的信息进行；接受被调查方提供的非公开信息使用的，必须对信息的适当性实施尽职甄别。",
            "questions": "I．优先根据乙公司公开披露的信息进行审慎调查<br>II．优先根据第三方提供的信息进行审慎调查<br>III．乙公司提供非公开信息时，甲银行对信息的适当性实施尽职甄别<br>IV．不接受且不使用乙公司提供的非公开信息",
            "question": "A．I、IV\nB．II、III\nC．II、IV\nD．I、III",
            "answer": "D",
            "explain": "开展审慎调查应当优先根据被调查方公开披露的信息进行；接受被调查方提供的非公开信息使用的，必须对信息的适当性实施尽职甄别。"
        },
        {
            "title": "基金经理不得直接向交易员下达投资指令或者直接进行交易，这项规定是依据（　　）。",
            "question": "A．投资决策授权制度\nB．投资风险评估与管理制度\nC．投资对象选库制度\nD．集中交易制度",
            "answer": "D",
            "explain": "基金交易业务控制的主要内容：(1)基金交易应实行集中交易制度，基金经理不得直接向交易员下达投资指令或者直接进行交易。(2)公司应当建立交易监测系统、预警系统和交易反馈系统，完善相关的安全设施。"
        },
        {
            "title": "在举办投资者保护活动时，最适合作为演讲嘉宾或演讲活动内容的是（　　）。",
            "question": "A．播放基金监管机构投教活动宣传视频和材料\nB．证券公司无基金销售资格的经纪人对基金销售规定的解读\nC．即将发行的公募基金的基金经理对该新基金操作方法和盈利预测的介绍\nD．证券公司研究所研究员对基金盈利模型的讲解",
            "answer": "A",
            "explain": "随着国内基金业的发展以及基金个人投资者规模的上升，投资者教育工作开始深入投资者的生活中。中国证券投资基金业协会及基金公司采用在线路演、行业主题沙龙、专题讲座、培训会、全国巡回报告会等形式传播基金知识；同时，基金业协会还将各种基金宣传材料开发成投资者教育游戏、基金知识动画片，多层次、多角度地开展有声有色的投资者教育工作。"
        },
        {
            "title": "按《私募投资基金监督管理暂行办法》规定，相关主体需要向私募基金投资人如实披露基金投资、资产负债、投资收益分配、基金承担的费用和业绩报酬等重大信息，该相关主体包括（　　）。",
            "questions": "I．基金管理人<br>II．基金托管人<br>III．基金监管部门<br>IV．审计基金合同的会计师事务所",
            "question": "A．I\nB．I、II、III\nC．I、II、III、IV\nD．I、II",
            "answer": "D",
            "explain": "《私募投资基金监督管理暂行办法》规定，私募基金管理人、私募基金托管人应当按照合同约定，如实向投资者披露基金投资、资产负债、投资收益分配、基金承担的费用和业绩报酬、可能存在的利益冲突情况以及可能影响投资者合法权益的其他重大信息，不得隐瞒或者虚假记载。"
        }, {
            "title": "关于基金销售机构与互联网机构合作开展货币基金互联网销售的业务，以下表述错误的是（　　）。",
            "question": "A．以显著方式向投资人提示提供基金销售服务的主体\nB．对合作的信息保障安全等进行明确的规定\nC．以理财账户或者服务平台的名义代替货币基金名称\nD．需要向投资人揭示投资风险",
            "answer": "C",
            "explain": "基金管理人、基金销售机构独立或者与互联网机构等其他机构合作开展货币市场基金互联网销售业务时，应当采取显著方式向投资人揭示提供基金销售服务的主体、投资风险以及销售的货币市场基金名称，不得以理财账户或者服务平台的名义代替基金名称，并对合作业务范围、法律关系界定、信息安全保障、客户信息保密、合规经营义务、应急处置机制、防范非法证券活动、合作终止时的业务处理方案、违约责任承担和投资人权益保护等进行明确约定。"
        },
        {
            "title": "某基金销售有限公司主要依托互联网进行基金销售，该公司基金网于2017年12月10日推出一项名为“十全十美”的年终客户大回馈活动，活动持续10天。活动期间，凡是在该公司基金网参加“十全十美”活动并将活动信息分享给好友的，即可获得相应数量货币基金份额。证监会派出机构对其进行现场检查时，发现以下事实：",
            "questions": "I．该活动收益率由货基收益及分享奖励两部分组成，分享奖励由该公司自行补贴<br>II．将货基收益和分享奖励叠加，投资者参加活动的投资收益类别最高档可达到10%<br>III．宣传资料显示：“业绩稳健，欲购从速”，“可安心享受成长”<br>IV．在宣传资料刊登13个工作日后，该公司将宣传资料发送至中国证监会派出机构进行报备关于该公司的上述做法，其中不符合规定的是（　　）。",
            "question": "A．I．II．III\nB．I．II．IV\nC．I．II．III．IV\nD．II．III．IV",
            "answer": "C",
            "explain": "宣传资料需示“业绩稳健，欲购从速”，“可安心享受成长”。"
        },
        {
            "title": "基金公司岗前职业道德教育应该达到的目标是（　　）。",
            "questions": "I．使拟从业者了解基金职业道德规范的主要内容<br>II．使拟从业者了解基金职业所面临的道德风险<br>III．培养拟从业者的基金道德情感和观念<br>IV．灌输拟从业人员公司利益至上的理念",
            "question": "A．I、II、III、IV\nB．I、II、III\nC．I、III、IV\nD．II、III、IV",
            "answer": "B",
            "explain": "基金职业道德教育需要完成三个方面目标：一是使拟从业者了解基金职业道德规范的主要内容；二是使拟从业者了解基金职业所面临的道德风险；三是培养拟从业者的基金道德情感和观念。岗前教育，可以使得基金从业人员在上岗之前就熟悉职业道德的要求，为其就职以后爱岗敬业、秉持正确的职业价值观而从事职业活动奠定良好的基础。"
        },
        {
            "title": "某新设基金公司对于人员的以下安排中，不合规的是（　　）。",
            "question": "A．分管投资的副总经理为某基金拟任基金经理\nB．督察长分管合规和基金运营\nC．总经理分管销售和市场\nD．分管运营的副总经理为首席信息官",
            "answer": "B",
            "explain": "公司应保证督察长工作的独立性，不得安排或者要求督察长从事基金销售、投资等与其履行职责相冲突的职务和工作。"
        },
        {
            "title": "某基金管理公司的总经理在内部会议上谈到自己对风险管理的认识，以下他的观点存在错误的是（　　）。",
            "question": "A．风险管理是公司有效管理各环节风险的持续过程\nB．风险管理是公司风险管理职能部门独自承担的职责\nC．董事会制定公司风险管理战略和风险应对策略\nD．董事会应当确定公司风险管理的总体目标",
            "answer": "B",
            "explain": "基金公司的风险管理是指基金公司围绕公司总体经营战略，从董事会、管理层到全体员工全员参与，在日常经营中，识别潜在风险，评估风险的影响程度，并根据公司风险偏好制定风险应对策略，有效管理公司各环节风险的持续过程。"
        },
        {
            "title": "以下属于私募基金的合格投资者的是（　　）。",
            "question": "A．总资产3000万元、净资产600万元的有限责任公司\nB．金融资产200万元的自然人\nC．在中国证券投资基金业协会备案的私募股权基金，按照私募基金合同约定投资另外一个私募股权基金60万元\nD．非金融总资产3000万元、过去三年个人年均收入30万元的自然人",
            "answer": "C",
            "explain": "私募基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元且符合下列相关标准的单位和个人：①净资产不低于1000万元的单位；②金融资产不低于300万元或者最近3年个人年均收入不低于50万元的个人。上述金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。"
        }, {
            "title": "某基金销售机构对尚未购买过基金产品的投资人甲进行风险承受能力调查和评价，以下行为合规的是（　　）。",
            "question": "A．对投资人完成首次风险承受能力调查和评价后，该机构今后无需对其进行重复调查\nB．对投资人风险承受能力的调查和评价可以依据其提供的银行对其风险能力\nC．对于放弃接受调查的投资人，该机构通过其他合理规则或方法对其风险承受能力进行了调查\nD．为保护商业机密，该机构未对投资人公开调查和评价方法",
            "answer": "B",
            "explain": "基金销售机构应当在基金投资人首次开立基金交易账户时或首次购买基金产品前对基金投资人的风险承受能力进行调查和评价；对已经购买了基金产品的基金投资人，基金销售机构也应当追溯调查，评价该基金投资人的风险承受能力。基金销售机构可以采用当面、信函、网络或对已有的客户信息进行分析等方式对基金投资人的风险承受能力进行调查，并向基金投资人及时反馈评价的结果。基金投资人放弃接受调查"
        },
        {
            "title": "基金管理人运用固有资金认购本公司的新基金时，基金管理人应披露的事项包含（　　）。",
            "question": "A．申购赎回价格\nB．适用的费率\nC．基金管理人认购的金额\nD．自有资金的来源",
            "answer": "B",
            "explain": "除依法披露基金财产管理业务活动相关的事项外，对管理人运用固有资金进行基金投资的事项，基金管理人也应履行相关披露义务，包括：认购基金份额的，在基金合同生效公告中载明所认购的基金份额、认购日期、适用费率等情况；申购、赎回或者买卖基金份额的，在基金季报中披露。"
        },
        {
            "title": "基金管理公司从公司章程、规章制度、工作流程、议事规则等的制定到公司各级组织机构职权的行使以及公司员工的从业行为，都应体现的利益优先原则是（　　）。",
            "question": "A．法人利益优先\nB．员工利益优先\nC．基金份额持有人利益优先\nD．股东利益优先",
            "answer": "C",
            "explain": "中国证监会《证券投资基金行业高级管理人员任职管理办法》(2004)规定，高级管理人员、基金管理公司基金经理应当维护所管理基金的合法利益，在基金份额持有人的利益与基金管理公司、基金托管银行的利益发生冲突时，应当坚持基金份额持有人利益优先的原则；不得从事或者配合他人从事损害基金份额持有人利益的活动。"
        },
        {
            "title": "某基金管理公司募集并成立一只QDII房地产基金。根据现行法规，该基金禁止投资于（　　）。",
            "question": "A．房地产信托凭证\nB．房地产抵押按揭\nC．住房按揭支持证券\nD．房地产上市公司股票",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "基金管理人可以从开放式基金财产中计提一定比例的（　　），用于基金的持续销售和给基金份额持有人提供服务。",
            "question": "A．赎回费\nB．申购费\nC．认购费\nD．销售服务费",
            "answer": "D",
            "explain": "基金管理人与基金销售机构可以在基金销售协议中约定依据基金销售机构销售基金的保有量提取一定比例的客户维护费，即销售服务费，用以向基金销售机构支付客户服务及销售活动中产生的相关费用。基金销售机构收取客户维护费的，应当符合中国证监会关于基金销售费用的规定。"
        },
        {
            "title": "关于货币市场基金公告，以下说法正确的是（　　）。",
            "questions": "I．与其他普通公募基金一样，货币市场基金也需要定期披露基金资产净值、份额净值和份额累计净值等信息<br>II．货币市场基金不同于其他普通类型公募基金定期披露份额净值，而是需要披露每万份基金收益和最近7日年化收益率<br>III．类似其他普通公募基金，货币市场基金收益公告按照披露时间的不同可分为封闭期公告和开放日公告两类<br>IV．不同于其他普通类型公募基金，货币市场基金收益公告按照披露时间的不同可分为封闭期的收益公告、开放日的收益公告和节假日的收益公告三类",
            "question": "A．I、III\nB．I、IV\nC．II、IV\nD．II、III",
            "answer": "C",
            "explain": "货币市场基金每日分配收益，份额净值保持1元不变，因此，货币市场基金不像其他类型基金那样定期披露份额净值，而是需要披露收益公告，包括每万份基金收益和最近7日年化收益率。"
        },
        {
            "title": "关于基金管理人内部控制机构设置，以下表述错误的是（　　）。",
            "question": "A．基金管理人应建立专职的内部控制机构\nB．基金管理人从组织上强化内部控制\nC．基金管理人所有员工都应该重视内部控制\nD．内部控制机制要兼顾企业的商业利润",
            "answer": "D",
            "explain": "在内部控制机构设置上，不能出现重眼前商业利润，不注重专职内部控制机构建立的偏向。建立健全基金管理人内部控制机构，从组织上强化内部控制，引导基金管理人所有员工重视内部控制。"
        }, {
            "title": "以下关于各类型基金投资说法正确的是（　　）。",
            "question": "A．债券基金仅投资于债券\nB．基金中的基金仅投资于不同基金份额\nC．股票基金仅投资于股票\nD．货币市场基金仅投资于货币市场工具",
            "answer": "D",
            "explain": "股票型、债券型、FOF基金均是投资对应资产达到80%以上而不是100%，货币市场基金仅投资于货币市场工具。"
        },
        {
            "title": "基金销售人员在为投资者办理基金开户和交易手续时，以下行为错误的是（　　）。",
            "question": "A．获取客户身份信息\nB．明确提示投资者注意投资基金的风险\nC．为投资者提供售后服务\nD．与投资者深度合作，以书面形式约定收益分成",
            "answer": "D",
            "explain": "基金销售人员在向投资者办理基金销售业务时，应当按照基金合同、招募说明书和发行公告等销售法律文件的规定代扣或收取相关费用，不得收取其他额外费用，也不得对不同投资者违规收取不同费率的费用。"
        },
        {
            "title": "基金监管的首要目标是（　　）。",
            "question": "A．保护基金投资人及相关当事人的合法权益\nB．实现基金市场公开、公平、公正\nC．规范证券投资基金活动\nD．促进证券投资基金和资本市场的健康发展",
            "answer": "A",
            "explain": "依法保护投资人及相关当事人的合法权益，是基金监管的首要目标。"
        },
        {
            "title": "关于公募基金对于证券市场稳定和健康发展的意义，以下表述错误的是（　　）。",
            "question": "A．公募基金的管理人所形成的投资研究驱动、合规保障与运营支持的制度化投研体系，有利于市场合理定价\nB．公募基金以财务投资为主要目的，不参与上市公司的治理，有利于确定上市公司的治理管理\nC．公募基金有不同类型、不同风险收益特征，是资本市场变革和产品创新的源泉之一\nD．公募基金发挥专业理财优势，推动市场化价值判断体系，有利于倡导长期投资和理性的投资文化",
            "answer": "B",
            "explain": "公募基金对于证券市场稳定和健康发展的意义：(1)在投资组合管理过程中对所投资证券进行的深入研究与分析，有利于促进信息的有效利用和传播，有利于市场合理定价，有利于市场有效性的提高和资源的合理配置。"
        },
        {
            "title": "关于基金管理公司授权制管理，以下表述错误的是（　　）。",
            "question": "A．基金经理在特定紧急情况下可将投资决策权限授予交易员\nB．公司对已经获授权的部门和人员需进行评价和反馈\nC．公司重大业务授权应当采取书面形式，授权书应当明确授权内容和时效\nD．公司应建立授权标准和程序，确保授权制度的贯彻执行",
            "answer": "A",
            "explain": "基金管理人可以通过授权控制来控制业务获得的运作，授权控制应当贯穿于公司经营活动的始终。授权控制的主要内容包括：(1)股东会、董事会、监事会和管理层应当充分了解和履行各自的职权，建立健全公司授权标准和程序，确保授权制度的贯彻执行；(2)公司各业务部门、分支机构和公司员工应当在规定授权范围内行使相应的职责。"
        },
        {
            "title": "关于基金职业道德规范中保守秘密的含义，以下说法错误的是（　　）。",
            "question": "A．保守秘密是指基金从业人员不应泄漏或者披露客户的信息，除非该信息涉及客户或潜在客户的违法活动且依法应当披露\nB．保守秘密是指基金从业人员不应泄露或者披露客户的信息，除非客户或潜在客户允许披露此信息\nC．保守秘密仅对涉及销售的基金从业人员有约束效力\nD．保守秘密是指基金从业人员不应泄露或者披露客户的信息，除非该信息属于法律要求披露的信息",
            "answer": "C",
            "explain": "保守秘密是基金从业人员的一项法定义务，也是基金职业道德的一项基本规范。对所有的基金从业人员均有约束效力，并不只对销售人员。"
        }, {
            "title": "根据基金投资者适当性原则，基金销售机构应当了解并评价的内容包括（　　）。",
            "questions": "I．基金管理人<br>II．基金产品<br>III．基金投资人",
            "question": "A．II、III\nB．I、II、III\nC．I、II\nD．I、III",
            "answer": "B",
            "explain": "基金销售机构建立基金销售适用性管理制度，应当至少包括以下内容：(1)对基金管理人进行审慎调查的方式和方法；"
        },
        {
            "title": "关于某基金销售机构基金销售适用性相关的制度和程序，以下表述错误的是（　　）。",
            "question": "A．总部已制定相关制度和程序，需要分支机构再自行制定相关的制度和程序\nB．需要健全普通投资者的回访制度\nC．需要建立档案对销售人员进行管理\nD．需要对销售人员进行专门的培训",
            "answer": "A",
            "explain": "基金销售机构应当就基金销售适用性的理论和实践对基金销售人员实行专题培训。基金销售机构应建立对销售人员的考核、监督问责、培训等机制，规范销售人员履行投资者适当性职责。"
        },
        {
            "title": "基金招募说明书登载的下述内容，合规的是（　　）。",
            "questions": "I．股票型证券投资基金可以按照后端模式收取申购费<br>II．债券型证券投资基金的基金份额净值低于1元时，可以停止计提管理费<br>III．货币市场基金计提管理费，年费率为0.33%，不收取申购、赎回费<br>IV．混合型证券投资基金计提管理费，年费率为1%，并按照1元基金份额净值进行申购和赎回",
            "question": "A．II、III、IV\nB．III、IV\nC．I、II、III、IV\nD．I、II、III",
            "answer": "C",
            "explain": "招募说明书包含的重要信息：(1)基金运作方式；(2)从基金资产中列支的费用的种类、计提标准和方式；(3)基金份额的发售、交易、申购、赎回的约定，特别是买卖基金费用的相关条款；(4)基金的投资目标、投资方向、投资策略、业绩比较基准、风险收益特征。"
        },
        {
            "title": "下列不属于ETF申购赎回现金替代类型的是（　　）。",
            "question": "A．禁止现金替代\nB．必须现金替代\nC．选择现金替代\nD．可以现金替代",
            "answer": "C",
            "explain": "现金替代是指申购和赎回过程中，投资者按基金合同和招募说明书的规定，用于替代组合证券中部分证券的一定数量的现金。采用现金替代是为了在相关成分股股票停牌等情况下便利投资者的申购，提高基金运作的效率。"
        },
        {
            "title": "关于交易型开放式指数基金（ETF）运作的特点，以下表述正确的有（　　）。",
            "questions": "I．投资者申购、赎回ETF可通过场内交易所和场外代销网点进行<br>II．ETF采用实物申购、赎回机制<br>III．ETF是一种被动操作的指数基金<br>IV．当二级市场ETF发生溢价交易时，投资者可在二级市场买进ETF，然后在一级市场赎回，再在二级市场卖掉股票实现套利交易",
            "question": "A．I、II、III\nB．I、III、IV\nC．II、III\nD．II、III、IV",
            "answer": "C",
            "explain": "ETF是以某一选定的指数所包含的成分证券（股票、债券等）或商品为投资对象，依据构成指数的证券或商品的种类和比例，采取完全复制或抽样复制，进行被动投资的指数基金。"
        },
        {
            "title": "作为监管部门，中国证监会高度重视基金公司治理结构，颁布一系列针对基金公司治理的法律法规和指引，以下不属于针对（　　）。",
            "question": "A．《证券投资基金法》\nB．《证券投资基金管理公司治理准则（试行）》\nC．《证券投资基金管理公司管理办法》\nD．《证券投资基金高级管理人员管理办法》",
            "answer": "D",
            "explain": "我国基金监管活动的主要依据是《证券投资基金法》以及中国证监会、基金业协会、证券交易所发布的一系列相关的部门规章和自律规则。"
        }, {
            "title": "某基金管理公司被曝出信息技术部负责人利用公司投资组合的未公开信息进行个人账户交易的违规行为，经当地证监局勘察，以下属于该公司在内部控制方面存在的问题的是（　　）。",
            "question": "A．信息技术部负责人对公司所有投资组合有查询的权限\nB．允许基金经理与信息技术部员工在同一餐厅吃饭\nC．该公司没有对信息技术部员工进行轮岗\nD．该公司的大股东没有定期对公司进行审计",
            "answer": "A",
            "explain": "信息技术部负责人应只有管理信息技术部门的权限，这违反了独立性原则，不相容职责应当分离；其余选项均未违反成本效益、相互制约、独立性、有效性和健全性原则。"
        },
        {
            "title": "关于私募基金管理人登记，以下表述正确的是（　　）。",
            "question": "A．未经登记，单位和个人都可以使用“基金”或者“基金管理”字样进行证券投资活动\nB．担任私募基金管理人只需向中国证券投资基金业协会登记，无需经中国证监会审批\nC．根据《证券投资基金法》的规定，中国证监会委托中国证券投资基金业协会办理私募基金管理人登记\nD．对私募基金管理人实施登记可以有效防范金融风险的发生",
            "answer": "B",
            "explain": "我国对于非公开募集基金的基金管理人没有严格的市场准入限制，担任非公开募集基金的管理人无须中国证监会审批，而实行登记制度，即非公开募集基金的基金管理人只需向基金业协会登记即可。"
        },
        {
            "title": "基金管理人合规管理的基本原则包括（　　）。",
            "questions": "I．独立性原则<br>II．客观性原则<br>III．公正性原则<br>IV．专业性原则",
            "question": "A．I、II、III、IV\nB．I\nC．I、II\nD．I、II、III",
            "answer": "A",
            "explain": "合规管理的基本原则包括：(1)独立性原则：指合规部门和督察长在基金公司组织体系中应当有独立地位，合规管理应当独立于其他各项业务经营活动；"
        },
        {
            "title": "T日是投资者申购或赎回基金申请日，关于基金份额登记时间，以下表述错误的是（　　）。",
            "question": "A．货币市场基金通常是T+0日确认登记\nB．QDII基金通常是T+2日确认登记\nC．股票型基金通常是T-1日确认登记\nD．债券型基金通常是T+1日确认登记",
            "answer": "C",
            "explain": "对于不同基金品种，份额登记时间可能不一样，货币市场基金是T+0日登记，一般基金是T+1日登记，而QDII基金则通常是T+2日登记。"
        },
        {
            "title": "投资者按合同要求认购某基金管理人发行的资产管理计划份额，该资产管理计划拟投资于股票、债券、期货等投资标的，存续期2年。关于该资产管理计划，以下表述错误的是（　　）。",
            "questions": "I．该资产管理计划中，投资者为委托方，基金管理人为受托方<br>II．受托资产既可以是货币等金融资产，也可以是实物资产<br>III．在该资产管理计划中，投资者与基金管理人之间存在债权债务关系<br>IV．受投资者委托，该资产管理计划可以购买房地产",
            "question": "A．II、IV\nB．I、II、III\nC．II、III、IV\nD．I、II、III、IV",
            "answer": "C",
            "explain": "资产管理具有以下特征：(1)从参与方来看，资产管理包括委托方和受托方，委托方为投资者，受托方为资产管理人。资产管理人根据投资者授权，进行资产投资。"
        },
        {
            "title": "基金管理人制定内部控制制度的（　　），是指在内控制度制定时，需考虑公司运作管理的每个方面，不得留有制度上的空白或漏洞。",
            "question": "A．审慎性原则\nB．合法、合规性原则\nC．适时性原则\nD．全面性原则",
            "answer": "D",
            "explain": "全面性原则指的是内部控制制度应当涵盖公司经营管理的各个环节，不得留有制度上的空白或漏洞，应尽量保持制度的全面完善。"
        }, {
            "title": "根据基金宣传推介材料规范性要求，以下属于不当宣传用语的是（　　）。",
            "questions": "I．坐享财富增长<br>II．安心享受成长<br>III．长期稳赚或尽享牛市<br>IV．认购日期截止到*年*月*日",
            "question": "A．I、II、IV\nB．II、III、IV\nC．I、II、III\nD．I、II、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于契约型基金与公司型基金的比较，以下表述错误的是（　　）。",
            "question": "A．契约型基金不具有法人资格，公司型基金具有法人资格\nB．契约型基金采用信托法律原理，依据基金合同营运基金；公司型基金则依据《公司法》规定的股份有限公司的组织方式，依基金\nC．契约型基金依据基金合同成立，投资者可以通过基金份额持有人大会表达意见；公司型基金的投资者是基金公司的股东\nD．契约型基金财产的债权不得与基金管理人的固有财产债务相互抵消；公司型基金财产则可以与基金管理人的固有财产债务",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "A商业银行代销B基金管理公司C基金产品，以下基金宣传推介行为合规的是（　　）。",
            "question": "A．宣传A商业银行品牌形象\nB．B基金管理公司承担损失\nC．预测C基金产品的投资业绩\nD．A商业银行承诺收益",
            "answer": "A",
            "explain": "承诺收益、承担损失、预测基金收益均属于基金宣传推介禁止行为，故“B基金管理公司承担损失、预测C基金产品的投资业绩、A商业银行承诺收益”均不选。"
        },
        {
            "title": "私募基金募集期间，应当在推介材料中向投资者披露的内容包括（　　）。",
            "questions": "I．中国证券基金协会私募基金公示信息<br>II．基金管理费和业绩报酬的计提标准和频率<br>III．私募基金收益与风险的匹配情况<br>IV．私募基金的外包情况",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．I、II\nD．I、III",
            "answer": "A",
            "explain": "私募基金推介材料内容包括但不限于：(1)私募基金的名称和基金类型。"
        },
        {
            "title": "股权投资基金募集机构及其从业人员在推介基金产品时，可以（　　）。",
            "question": "A．引用权威数据来源\nB．保证基金预期收益\nC．在微信朋友圈介绍基金信息\nD．宣传过往3个月的基金产品业绩",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "甲有1000元闲置资金，希望通过投资实现保值增值，但1000元最多只能购买1、2只股票，因此甲选择购买沪深300指数基金具有以下特点（　　）。",
            "question": "A．独立托管、保障安全\nB．严格监管、信息透明\nC．组合投资、分散风险\nD．利益共享、风险共担",
            "answer": "C",
            "explain": "组合投资、分散风险是基金的特点之一，具体表现：中小投资者由于资金量小，一般无法通过购买数量众多的股票分散投资，常会购买几十种甚至上百种股票，投资者购买基金就相当于用很少的资金购买了一篮子股票。因此本题中，甲的资金量小"
        }, {
            "title": "2017年7月4日，某销售机构对投资者小王进行了投资者风险评估，同日小王与该私募机构签订合约购买了与小王风险承受能力匹配的私募产品A。在随后的销售机构行为中，符合投资者适当性要求的是（　　）。",
            "questions": "I．2019年7月5日，如果该销售机构继续向小王推荐私募产品B，必须再对小王进行风险评估<br>II．2020年7月5日，如果该销售机构继续向小王推荐私募产品B，必须再对小王进行风险评估<br>III．2020年7月5日，如果小王要继续持有而不赎回私募产品A，该销售机构无需再对小王进行风险评估<br>IV．2023年7月5日，如果小王继续持有而不赎回私募产品A，该销售机构必须再对小王进行风险评估",
            "question": "A．II、III\nB．I、II、III、IV\nC．I、II、IV\nD．II、III、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "在基金销售中，关于普通投资者和专业投资者的描述，错误的是（　　）。",
            "question": "A．普通投资者在信息告知、风险警示和适当性匹配方面享有特别保护\nB．基金销售机构应当对普通投资者进行细化和管理，对专业投资者也需细化分类和管理\nC．基金销售机构在处理相关纠纷时，根据平等对待投资者原则，要求普通投资者和专业投资者承担举证责任\nD．普通投资者经过申请并通过基金销售机构审核同意可以转化为专业投资者",
            "answer": "C",
            "explain": "基金销售机构在销售过程中应遵循举证责任倒置原则，经营机构与普通投资者发生纠纷的，经营机构应当提供相关材料，证明其已向投资者履行相应义务。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/flfg-2.js